import React from 'react';
import { Redirect } from 'react-router-dom';
import MenuBar from '../../components/menuBar/MenuBar';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import FlightChangeSelectionContainer from './components/FlightChangeSelectionContainer';
import FlightChangeSelectionFooter from './components/FlightChangeSelectionFooter';
import FlightChangeSelectionHeader from './components/FlightChangeSelectionHeader';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import './FlightChangeSelection.css';
import PropTypes from 'prop-types';

var SEARCH_PNR_URI = 'checkout/api/v2/booking/search?';

const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object
};

const defaultProps = {
  showLoading: false
};

class FlightChangeSelection extends React.Component {
  constructor(props) {    
    super(props);    
    this.state = {
      isRedirect: false,
      urlRedirect: '',
      isSelectedOrigin: false,
      isSelectedDestiny: false,
      openModal: false
    };
  }

  componentDidMount() {
    this.search(this.props.location.state.pnrNumber);
  }

  handleChangeFlightSelect = () => {
    this.setState({
      isRedirect: true,
      urlRedirect: 'flightChange'
    });
  };

  handleSelectOrigin = () => {
    if (this.state.isSelectedOrigin === false) {
      this.setState({
        isSelectedOrigin: true
      });
    } else {
      this.setState({
        isSelectedOrigin: false
      });
    }
  };

  handleSelectDestiny = () => {
    if (this.state.isSelectedDestiny === false) {
      this.setState({
        isSelectedDestiny: true
      });
    } else {
      this.setState({
        isSelectedDestiny: false
      });
    }
  };

  search(PNRNumber) {
    this.setState({
      showLoading: true
    });    
    return fetch(SEARCH_PNR_URI + `pnr=${PNRNumber}`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json'
      }),
      credentials: 'same-origin'
    })
      .then(responseSearch => {
        if (responseSearch.ok) {
          return responseSearch.json();
        } else {
          this.showModal(I18n.translate('searchResult.msg.error'));
        }
      })
      .then(responseJson => {
        this.setState({
          pnr: responseJson,
          showLoading: false
        });
      })
      .catch(error => {
        this.setState({
          showLoading: false
        });
        this.showModal(I18n.translate('searchResult.msg.error'));
      });
  }

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };

  countPassengersTypes = () => {
    let childrenPassengers = 0;
    let infantPassengers = 0;
    let adultPassengers = 0;
    this.state.pnr.passengers.forEach(passenger => {
      switch (passenger.passengerType) {
        case 'ADULT':
          adultPassengers++;
          break;

        case 'INFANT':
          infantPassengers++;
          break;

        case 'CHILD':
          childrenPassengers++;
          break;

        default:
          break;
      }
    });
    return {
      childrenPassengers,
      infantPassengers,
      adultPassengers
    };
  };

  renderButtonLoading() {
    return (
      <div className="flightOptions__spinner">
        <div>
          <i className="icon-spinner" />
        </div>
        <span id="wait-message">{I18n.translate('wait')}</span>
        <span id="searchingFlights-message">
          {I18n.translate('searchResult.msg.searchingFlights')}
        </span>
      </div>
    );
  }

  render() {
    return (
      <div>
        <MenuBar hideChangeSearch={true} />
        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={[
            'features.breadcrumb.reservation',
            'features.breadcrumb.pnrDetail',
            'features.breadcrumb.change'
          ]}
          actual="features.breadcrumb.change"
        />
        <div id="FlightChangeSelection">
          {this.state.showLoading ? (
            this.renderButtonLoading()
          ) : this.state.pnr ? (
            <div className="section__outer">
              <FlightChangeSelectionHeader passengers={this.state.pnr.passengers} />
              <FlightChangeSelectionContainer
                originFlight={this.state.pnr.cart.items[0].departureFlight}
                destinyFlight={this.state.pnr.cart.items[0].returnFlight}
                onChangeOrigin={this.handleSelectOrigin}
                onChangeDestiny={this.handleSelectDestiny}
                isSelectedOrigin={this.state.isSelectedOrigin}
                isSelectedDestiny={this.state.isSelectedDestiny}
              />
              <FlightChangeSelectionFooter
                isSelectedOrigin={this.state.isSelectedOrigin}
                isSelectedDestiny={this.state.isSelectedDestiny}
                handleChangeFlightSelect={this.handleChangeFlightSelect}
              />
            </div>
          ) : null}
          <InfoModal
            id="modalError"
            message={this.state.messageInfo}
            showModal={this.state.openModal}
            close={this.closeModal}
            ref={c => {
              this.modalError = c;
            }}
          />
        </div>
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                isSelectedOrigin: this.state.isSelectedOrigin,
                isSelectedDestiny: this.state.isSelectedDestiny,
                passengersInfo: this.countPassengersTypes(),
                pnrNumber: this.props.location.state.pnrNumber,
                azulNumber: this.props.location.state.azulNumber,
              }
            }}
          />
        ) : null}
      </div>
    );
  }
}

FlightChangeSelection.propTypes = propTypes;
FlightChangeSelection.defaultProps = defaultProps;

export default FlightChangeSelection;



// WEBPACK FOOTER //
// ./src/page/flightChangeSelection/FlightChangeSelection.jsx